import React, { useMemo, useState } from 'react';
import { Autocomplete, TextField, Box, Checkbox, Typography, CircularProgress } from '@mui/material';
import CustomListbox from '../../../components/CustomListbox';

const RoleSelect = ({
  roles = [],
  selected = [],
  isLoading = false,
  onChange,
  placeholder = 'Select roles',
  selectedCountLabel,
    errors
}) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const selectedObjects = useMemo(() => {
    return roles.filter((role) => selected.includes(role.id));
  }, [roles, selected]);

  const countLabel =
    selectedCountLabel?.replace('{count}', String(selectedObjects.length)) ??
    `${selectedObjects.length} Role(s) selected`;

  return (
    <Box>
      <Autocomplete
        multiple
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={roles}
        loading={isLoading}
        disabled={isLoading}
        value={selectedObjects}
        inputValue={inputValue}
        disableCloseOnSelect
        ListboxComponent={CustomListbox}
        ListboxProps={{
          selectAllLabel: `Select All ${roles.length} roles`,
          onSelectAll: () => onChange(roles.map((role) => role.id)),
          onClearAll: () => onChange([]),
          sx: {
            paddingTop: 0,
            maxHeight: 256,
            overflowY: 'auto',
          },
        }}
        onInputChange={(event, value, reason) => {
          if (reason === 'input') {
            setInputValue(value);
          }
        }}
        getOptionLabel={(option) => option?.name ?? ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(_, newValue) => {
          onChange(newValue.map((role) => role.id));
        }}
        renderTags={(value) => {
          if (!value.length || open) return null;
          return <span style={{ marginLeft: 8 }}>{countLabel}</span>;
        }}
        renderOption={(props, option, { selected: isSelected }) => (
          <li {...props}>
            <Checkbox checked={isSelected} sx={{ marginRight: 1 }} />
            <Typography fontSize={14} fontWeight={500}>
              {option.name}
            </Typography>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={selectedObjects.length === 0 || open ? placeholder : ''}
            error={errors}
            helperText={
              errors && selectedObjects.length === 0?
                "Role is mandatory":""
          }
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? <CircularProgress color="inherit" size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default RoleSelect;
